import { Box, Typography } from '@mui/material';
import { buildPoolHealthRows, EMPTY_PLACEHOLDER } from '../wingmanIntelligenceMetrics';

const TRACK_BG = '#E8E8E8';
const BAR_HEIGHT = 10;

const SingleBar = ({ value, color }) => (
  <Box
    sx={{
      height: BAR_HEIGHT,
      borderRadius: '999px',
      bgcolor: TRACK_BG,
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        width: `${Math.min(100, Math.max(0, value))}%`,
        height: '100%',
        bgcolor: color,
        borderRadius: '999px',
        transition: 'width 0.4s ease',
      }}
    />
  </Box>
);

const SplitBar = ({ primary, secondary, primaryColor, secondaryColor }) => (
  <Box
    sx={{
      display: 'flex',
      height: BAR_HEIGHT,
      borderRadius: '999px',
      bgcolor: TRACK_BG,
      overflow: 'hidden',
    }}
  >
    <Box
      sx={{
        width: `${primary}%`,
        height: '100%',
        bgcolor: primaryColor,
        flexShrink: 0,
      }}
    />
    <Box
      sx={{
        width: `${secondary}%`,
        height: '100%',
        bgcolor: secondaryColor,
        flexShrink: 0,
      }}
    />
  </Box>
);

const PoolHealthSection = ({ rows = buildPoolHealthRows() }) => {
  return (
    <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant="subtitle1"
        component="h2"
        sx={{
          fontWeight: 700,
          color: '#1B1B1F',
          letterSpacing: '-0.01em',
          mb: 2.5,
        }}
      >
        Pool Health Indicators
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.25 }}>
        {rows.map((row) => (
          <Box key={row.key}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'baseline',
                gap: 1,
                mb: 1,
              }}
            >
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: '#1B1B1F',
                  lineHeight: 1.35,
                  flex: 1,
                  minWidth: 0,
                }}
              >
                {row.label}
              </Typography>
              <Typography
                sx={{
                  fontSize: 14,
                  fontWeight: 500,
                  color: row.statusColor,
                  whiteSpace: 'nowrap',
                  flexShrink: 0,
                }}
              >
                {row.statusLabel ?? EMPTY_PLACEHOLDER} ({row.statusDetail ?? EMPTY_PLACEHOLDER})
              </Typography>
            </Box>

            {row.type === 'split' ? (
              <SplitBar
                primary={row.primarySegment ?? 0}
                secondary={row.secondarySegment ?? 0}
                primaryColor={row.primaryColor}
                secondaryColor={row.secondaryColor}
              />
            ) : (
              <SingleBar value={row.value ?? 0} color={row.barColor} />
            )}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PoolHealthSection;
